<div class="add-container">
    <h1 class="add-title">Adaugă Tip Utilizator</h1>
    <form class="add-card__form" [formGroup]="form" (submit)="submitForm()">
        <div class="row">
            <div class="col add-field">
                <mat-form-field appearance="fill">
                    <mat-label>ID Utilizator Asignat</mat-label>
                    <input type="number" matInput formControlName="id_user_assigned" />
                    <mat-error *ngIf="!form.controls['id_user_assigned'].valid && form.controls['id_user_assigned'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col add-field">
                <mat-form-field appearance="fill">
                    <mat-label>ID Utilizator Declarator</mat-label>
                    <input type="number" matInput formControlName="id_user_submitter" />
                    <mat-error *ngIf="
                !form.controls['id_user_submitter'].valid &&
                form.controls['id_user_submitter'].touched
              ">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        
        <div class="row">
            <div class="col add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Departament</mat-label>
                    <mat-select
                      formControlName="id_departament"
                    >
                      <mat-option
                        *ngFor="let departament of departamente$ | async"
                        [value]="departament.id"
                      >
                        {{ departament.name }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
            </div>
            <div class="col add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Direcție</mat-label>
                    <mat-select
                      formControlName="id_directie"
                    >
                      <mat-option
                        *ngFor="let directie of directii$ | async"
                        [value]="directie.id"
                      >
                        {{ directie.name }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Compartiment</mat-label>
                    <mat-select
                      formControlName="id_compartiment"
                    >
                      <mat-option
                        *ngFor="let compartiment of compartimente$ | async"
                        [value]="compartiment.id"
                      >
                        {{ compartiment.name }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
            </div>
            <div class="col add-field">
                <mat-form-field appearance="fill">
                    <mat-label>ID Utilizator Modificat</mat-label>
                    <input type="text" matInput formControlName="id_modified_user" />
                    <mat-error *ngIf="
                !form.controls['id_modified_user'].valid &&
                form.controls['id_modified_user'].touched
              ">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>


        <div class="row">
            <div class="col add-field">
                <mat-form-field appearance="fill">
                    <mat-label>ID Cetățean</mat-label>
                    <input type="number" matInput formControlName="id_cetatean" />
                    <mat-error *ngIf="
                !form.controls['id_cetatean'].valid &&
                form.controls['id_cetatean'].touched
              ">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Tip Cerere</mat-label>
                    <mat-select
                      formControlName="id_cerere_type"
                    >
                      <mat-option
                        *ngFor="let request of requestTypes$ | async"
                        [value]="request.id"
                      >
                        {{ request.name }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Cerere Status</mat-label>
                    <mat-select
                      formControlName="id_cerere_status"
                    >
                      <mat-option
                        *ngFor="let status of requestStatuses$ | async"
                        [value]="status.id"
                      >
                        {{ status.name }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
            </div>
            <div class="col add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Cerere Prioritate</mat-label>
                    <mat-select
                      formControlName="id_cerere_priority"
                    >
                      <mat-option
                        *ngFor="let priority of requestPriorities$ | async"
                        [value]="priority.id"
                      >
                        {{ priority.name }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
            </div>
        </div>


        <div class="row">
            <div class="col add-field">
                <mat-form-field appearance="fill">
                    <mat-label>ID Cerere Departament</mat-label>
                    <input type="number" matInput formControlName="id_cerere_departament" />
                    <mat-error *ngIf="
                !form.controls['id_cerere_departament'].valid &&
                form.controls['id_cerere_departament'].touched
              ">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Subiect</mat-label>
                    <input type="text" matInput formControlName="subject" />
                    <mat-error *ngIf="
                !form.controls['subject'].valid &&
                form.controls['subject'].touched
              ">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Descriere</mat-label>
                    <input type="text" matInput formControlName="description" />
                    <mat-error *ngIf="
                !form.controls['description'].valid &&
                form.controls['description'].touched
              ">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col add-field">
                <mat-form-field class="col add-field">
                    <mat-label>Dată email</mat-label>
                    <input matInput [matDatepicker]="picker1" formControlName="email_date" readonly
                    (focus)="picker1.open()" />
                    <mat-error
                        *ngIf="
                        !form.controls['email_date'].valid &&
                        form.controls['email_date'].touched
                      ">
                        Câmp obligatoriu
                    </mat-error>
                    <mat-hint>ZZ/LL/AAAA</mat-hint>
                    <mat-datepicker-toggle matIconSuffix [for]="picker1"></mat-datepicker-toggle>
                    <mat-datepicker #picker1></mat-datepicker>
                </mat-form-field>
            </div>
            <div class="col add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Status email</mat-label>
                    <input type="number" matInput formControlName="email_status" />
                    <mat-error *ngIf="
                !form.controls['email_status'].valid &&
                form.controls['email_status'].touched
              ">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col add-field">
                <mat-form-field appearance="fill">
                    <mat-label>IP</mat-label>
                    <input type="text" matInput formControlName="ip" />
                    <mat-error *ngIf="
                !form.controls['ip'].valid &&
                form.controls['ip'].touched
              ">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Sursă</mat-label>
                    <input type="number" matInput formControlName="source" />
                    <mat-error *ngIf="
                !form.controls['source'].valid &&
                form.controls['source'].touched
              ">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col add-field">
                <mat-form-field appearance="fill">
                    <mat-label>ID Cetățean M</mat-label>
                    <input type="number" matInput formControlName="id_cetatean_m" />
                    <mat-error *ngIf="
                !form.controls['id_cetatean_m'].valid &&
                form.controls['id_cetatean_m'].touched
              ">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col add-field">
                <mat-form-field class="col add-field">
                    <mat-label>Dată Validată</mat-label>
                    <input matInput [matDatepicker]="picker_validated_date" formControlName="validated_date" readonly
                    (focus)="picker_validated_date.open()" />
                    <mat-error
                        *ngIf="
                        !form.controls['validated_date'].valid &&
                        form.controls['validated_date'].touched
                      ">
                        Câmp obligatoriu
                    </mat-error>
                    <mat-hint>ZZ/LL/AAAA</mat-hint>
                    <mat-datepicker-toggle matIconSuffix [for]="picker_validated_date"></mat-datepicker-toggle>
                    <mat-datepicker #picker_validated_date></mat-datepicker>
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col add-field">
                <mat-form-field appearance="fill">
                    <mat-label>ID Utilizator Validat</mat-label>
                    <input type="number" matInput formControlName="validated_user_id" />
                    <mat-error *ngIf="
                !form.controls['validated_user_id'].valid &&
                form.controls['validated_user_id'].touched
              ">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Nume Utilizator Validat</mat-label>
                    <input type="number" matInput formControlName="validated_user_name" />
                    <mat-error *ngIf="
                !form.controls['validated_user_name'].valid &&
                form.controls['validated_user_name'].touched
              ">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Observații Utilizator Validat</mat-label>
                    <input type="text" matInput formControlName="validated_obs" />
                    <mat-error *ngIf="
                !form.controls['validated_obs'].valid &&
                form.controls['validated_obs'].touched
              ">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col add-field">
                <mat-form-field class="col add-field">
                    <mat-label>Dată anulare</mat-label>
                    <input matInput [matDatepicker]="picker_cancel_date" formControlName="cancel_date" readonly
                    (focus)="picker_cancel_date.open()" />
                    <mat-error
                        *ngIf="
                        !form.controls['cancel_date'].valid &&
                        form.controls['cancel_date'].touched
                      ">
                        Câmp obligatoriu
                    </mat-error>
                    <mat-hint>ZZ/LL/AAAA</mat-hint>
                    <mat-datepicker-toggle matIconSuffix [for]="picker_cancel_date"></mat-datepicker-toggle>
                    <mat-datepicker #picker_cancel_date></mat-datepicker>
                </mat-form-field>
            </div>
            <div class="col add-field">
                <mat-form-field appearance="fill">
                    <mat-label>ID Utilizator Anulare</mat-label>
                    <input type="number" matInput formControlName="cancel_user_id" />
                    <mat-error *ngIf="
                !form.controls['cancel_user_id'].valid &&
                form.controls['cancel_user_id'].touched
              ">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Nume Utilizator Anulare</mat-label>
                    <input type="text" matInput formControlName="cancel_user_name" />
                    <mat-error *ngIf="
                !form.controls['cancel_user_name'].valid &&
                form.controls['cancel_user_name'].touched
              ">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Observații Anulare</mat-label>
                    <input type="text" matInput formControlName="cancel_obs" />
                    <mat-error *ngIf="
                !form.controls['cancel_obs'].valid &&
                form.controls['cancel_obs'].touched
              ">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Tip Anulare</mat-label>
                    <input type="text" matInput formControlName="cancel_type" />
                    <mat-error *ngIf="
                !form.controls['cancel_type'].valid &&
                form.controls['cancel_type'].touched
              ">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col add-field">
                <mat-form-field class="col add-field">
                    <mat-label>Dată Rezolvare</mat-label>
                    <input matInput [matDatepicker]="picker_resolved_date" formControlName="resolved_date" readonly
                    (focus)="picker_resolved_date.open()" />
                    <mat-error
                        *ngIf="
                        !form.controls['resolved_date'].valid &&
                        form.controls['resolved_date'].touched
                      ">
                        Câmp obligatoriu
                    </mat-error>
                    <mat-hint>ZZ/LL/AAAA</mat-hint>
                    <mat-datepicker-toggle matIconSuffix [for]="picker_resolved_date"></mat-datepicker-toggle>
                    <mat-datepicker #picker_resolved_date></mat-datepicker>
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Nume Utilizator Modificat</mat-label>
                    <input type="text" matInput formControlName="modified_user_name" />
                    <mat-error *ngIf="
                !form.controls['modified_user_name'].valid &&
                form.controls['modified_user_name'].touched
              ">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="add-action-btns">
            <button class="buttons" type="button" mat-flat-button (click)="closeDialog()">
                {{ helper.dialogConfig.buttonLabels.close }}
            </button>
            <button class="buttons" type="submit" mat-flat-button color="primary" [disabled]="form.invalid">
                {{ helper.dialogConfig.buttonLabels.save }}
            </button>
        </div>
    </form>
    <div class="section-spinner position-absolute" *ngIf="isLoading">
        <div class="spinner position-absolute top-50 start-50 translate-middle">
            <mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
        </div>
    </div>
</div>